// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState as getDefaultCriteriaState} from '../state/criteria';
import {findMatchingAccount, findMatchingKey} from '../../../claim/shared/services/claim-shared-helper';
import actions from '../../actions-list';

const updateClaimHistoryCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const selectClaimType = (state, action) =>
    Criteria.update(state, {
        claimType: {
            $set: findMatchingKey(action.claimType, action.claimTypeCollection)
        }
    });

const selectCreditMemoProcessDate = (state, action) =>
    Criteria.update(state, {
        creditMemoProcessDate: {
            from: {
                $set: action.creditMemoDate.from
            },
            to: {
                $set: action.creditMemoDate.to
            }
        }
    });

const selectDealer = (state, action) =>
    Criteria.update(state, {
        selectedDealer: {
            $set: findMatchingAccount(action.dealer, action.dealerCollection)
        }
    });

const resetClaimHistoryCriteria = () => getDefaultCriteriaState();

export default (state = getDefaultCriteriaState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_HISTORY_CRITERIA]: updateClaimHistoryCriteria,
        [actions.SELECT_CREDIT_MEMO_PROCESS_DATE]: selectCreditMemoProcessDate,
        [actions.RESET_CLAIM_HISTORY_REPORT]: resetClaimHistoryCriteria,
        [actions.SELECT_CLAIM_HISTORY_CLAIM_TYPE]: selectClaimType,
        [actions.SELECT_CLAIM_HISTORY_DEALER]: selectDealer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/claim-history/reducers/criteria.js